import { Input, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCustomers } from '../../../store/slices/customer-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const CustomerForm = () => {
    const [customerName, setCustomerName] = useState('');
    const [customerMobile, setCustomerMobile] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerCity, setCustomerCity] = useState('');
    const [customerCountry, setCustomerCountry] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');

    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: customers } = useSelector((state) => state.customer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchCustomers());
    }, []);

    useEffect(() => {
        console.log(MODE);
        if(MODE === 'EDIT' && customers.length) {
            const ID = searchParams.get('id');
            const selectedCustomer = customers.filter((item) => item.customer_id === ID);
            setCustomerName(selectedCustomer[0].customer_name);
            setCustomerMobile(selectedCustomer[0].customer_mobile_no);
            setCustomerEmail(selectedCustomer[0].customer_email);
            setCustomerCity(selectedCustomer[0].customer_city);
            setCustomerCountry(selectedCustomer[0].customer_country);
            setCustomerAddress(selectedCustomer[0].customer_address);
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, customers]);

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'customer_name': customerName,
            'customer_mobile_no': customerMobile,
            'customer_email': customerEmail,
            'customer_city': customerCity,
            'customer_country': customerCountry,
            'customer_address': customerAddress,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.customer_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/customer/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/customer-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setCustomerName('');
        setCustomerMobile('');
        setCustomerEmail('');
        setCustomerCity('');
        setCustomerCountry('');
        setCustomerAddress('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Customer</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Customer Name:</label>
                    <Input 
                        onChange={(e) => setCustomerName(e.target.value)} 
                        value={customerName}
                        size='large' 
                        placeholder='Customer Name' 
                    />
                </div>
                <div className='control'>
                    <label>Customer Mobile No:</label>
                    <Input 
                        onChange={(e) => setCustomerMobile(e.target.value)} 
                        value={customerMobile}
                        size='large' 
                        placeholder='Customer Mobile No' 
                    />
                </div>
                <div className='control'>
                    <label>Customer Email:</label>
                    <Input 
                        onChange={(e) => setCustomerEmail(e.target.value)} 
                        value={customerEmail}
                        size='large' 
                        placeholder='Customer Email' 
                    />
                </div>
                <div className='control'>
                    <label>Customer Country:</label>
                    <Input 
                        onChange={(e) => setCustomerCountry(e.target.value)} 
                        value={customerCountry}
                        size='large' 
                        placeholder='Customer Country' 
                    />
                </div>
                <div className='control'>
                    <label>Customer City:</label>
                    <Input 
                        onChange={(e) => setCustomerCity(e.target.value)} 
                        value={customerCity}
                        size='large' 
                        placeholder='Customer City' 
                    />
                </div>
                <div className='control'>
                    <label>Customer Address:</label>
                    <Input.TextArea
                        onChange={(e) => setCustomerAddress(e.target.value)} 
                        value={customerAddress} 
                        size='large'
                        rows={2}
                        placeholder='Customer Address' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default CustomerForm;


